import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpResponse, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthConfigService } from '../../../services/auth-config.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly authConfigService: AuthConfigService,
    private readonly router: Router
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Handle response
    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          if (event.body?.code === "UNAUTHORIZED") {
            this.router.navigateByUrl('page-not-authorized', { skipLocationChange: true });
            return;
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        // Handle specific errors
        let errorIndex = error.status.toString();
        if (errorIndex === '401') {
          localStorage.removeItem("loggedin_users");
          
          try {
            // Try to get OktaAuth instance (will only work after config is loaded)
            const oktaAuth = this.authConfigService.createOktaAuth();
            if (oktaAuth) {
              oktaAuth.signOut();
            }
          } catch (e) {
            // Config not loaded yet, ignore
            console.warn('OktaAuth not available yet:', e);
          }
        }
        return throwError(() => error);
      })
    );
  }
}